module.exports = __webpack_public_path__ + "static/birdseye-2c320d7a0c5931b7f33e22d3b7f4ff28.jpeg";